export const ORGANIZATION_INFOS = {
	CNES: [
        'CADASTRO NACIONAL DE ESTABELECIMENTOS DE SAÚDE (CNES)'
    ]
}